import { useContext, useEffect, useState } from 'react';
import { getStorageValue, setStorageValue } from '@portal-internet/core';
import { setDigitalData, setGlobalEvars } from './audiencies-datalayer';
import { HistoryContext } from 'context/corporatiu/HistoryProvider';
import { useUser } from 'hooks/useUser';
import { useViewport } from 'hooks/corporatiu/useViewport';
import { useRouter } from 'next/router';
import __isEmpty from 'lodash/isEmpty';

export default function Audiencies(props) {
    const { getPreviousPage } = useContext(HistoryContext);
    const { viewport } = useViewport();
    const { isAuthenticated, id, deviceUid } = useUser();
    const router = useRouter();
    const [dataClickOrigin, setDataClickOrigin] = useState({});

    const getDataClick = async () => {
        const data = await getStorageValue('ccma_click');
        if (data && data !== dataClickOrigin) {
            setDataClickOrigin(data);
            setStorageValue('ccma_click', {}, { path: '/', domain: '.3cat.cat', expires: 1 });
        }
    };

    useEffect(() => {
        getDataClick();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (typeof window === 'object') {
            if (window.s) {
                window.s.pageType = undefined;
            }
            const paginaAnterior = getPreviousPage();

            const tiraOrigen = dataClickOrigin?.name;
            const tiraTitles = dataClickOrigin?.titles;
            const digitalData = setDigitalData({
                ...props,
                isAuthenticated,
                id,
                deviceUid,
                viewport,
                router,
                paginaAnterior,
                tiraOrigen,
                tiraTitles
            });
            window.digitalData = digitalData;
            setGlobalEvars(digitalData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewport, isAuthenticated, id, deviceUid, router.asPath, dataClickOrigin]);
    useEffect(() => {
        let timerScroll = null;
        let timer = null;
        if (!__isEmpty(router.query.automatic_test) && router.query.automatic_test < MAX_REQUESTS) {
            timerScroll = setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
            }, 2500);
            timer = setTimeout(() => {
                const elems = document.querySelectorAll('a[href*="/3cat/"][href*="automatic_test"]:not([href*="/cercador/"]');
                const random = Math.floor(Math.random() * elems.length);
                elems[random]?.click();
            }, 3500);
        }
        return () => {
            clearTimeout(timer);
            clearTimeout(timerScroll);
        };
    }, [router.query.automatic_test]);

    return <></>;
}
